import { useLocation } from 'react-router-dom';

export function linksStartingWith(...links: string[]) {
  const { pathname } = useLocation();
  for (const i in links) {
    if (pathname.startsWith(links[i])) return true;
  }
  return undefined;
}
